import { render, staticRenderFns } from "./LsComment.vue?vue&type=template&id=724db2bc&"
import script from "./LsComment.vue?vue&type=script&lang=js&"
export * from "./LsComment.vue?vue&type=script&lang=js&"
import style0 from "./LsComment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports